<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{$t("Create registration")}}</h1>
          <div>
            <v-card raised  class="mb-4">
            </v-card>
            <v-card raised>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-form ref="form" v-model="valid">
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <v-flex class="mt-4" d-flex xs4>{{$t("Unloaded amount (kg)")}}:</v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            :rules="[true]"
                            v-model="item.NetWeightStr"
                            :v-mask="'#.##'"
                            :label="this.$t('Enter amount here')">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-flex class="mt-4" d-flex xs4>{{$t("Comment")}}:</v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            :label="this.$t('Enter comment here')">
                            v-model="item.Comment"
                            mask="#,##"
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-flex class="mt-0" d-flex xs4>{{$t("Images")}}:</v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md3 lg2 v-for="(image, index) in item.FileItems" :key="index">
                              <div class="image_container">
                                <img :src="image.ImageData" class="zoom">
                                <div class="after faded">
                                  <p class="black--text full text-left">
                                    <v-btn icon color="warning" @click="removeFile(index)">
                                      <v-icon>cancel</v-icon>
                                    </v-btn>
                                  </p>
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-flex xs12>
                            <v-input
                              :rules="[true]"
                              required="true"
                              :value="item.FileItems">
                              <v-layout row wrap>
                                <v-btn block color="primary" dark @click="onPickFile" :disabled="item.FileItems!=null ? item.FileItems.length >= 10 : false">
                                  {{$t("Select")}}
                                </v-btn>
                                <v-flex d-flex>{{$t("Min 1 picture. Max 10 images and max 10 MB")}}</v-flex>
                              </v-layout>
                            </v-input>
                            <input type="file" ref="image" name="image" accept="image/*" capture="environment" @change="onFilePicked">
                          </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-flex class="mt-4" d-flex >{{$t("GPS Position (latitude, longitude)")}}:</v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="item.GpsPos"
                            :label="item.GpsPos == null ? this.$t('Loading..') : ''"
                            readonly>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="mt-4" d-flex >{{$t("Plant")}}:</v-flex>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-flex shrink><v-select class="ml-0" hide-details="true" :items="PlantList" v-model="selectedPlant" @change="savePlant(selectedPlant)" :label="$t('Plant')"></v-select></v-flex>
                          </v-flex>
                        <v-flex text-right>
                          <v-btn class="mt-1 mr-1" @click.prevent="cancelRegistration" color="primary" type="primary">{{$t("Cancel")}}</v-btn>
                          <v-btn class="mt-1 mr-1 ml-3" @click.prevent="saveRegistration" color="success" :loading="submitting" type="primary" :disabled="validate(item)">{{$t("Save")}}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>

</template>

<script>
import filters from '@/core/mixins/common-filters'
import * as Security from '@/core/security'
import mediumZoom from 'medium-zoom'
import * as UnloadingFuel from '@/modules/unloading-fuel/unloading-fuel'
import { readAndCompressImage } from 'browser-image-resizer'
import { isNumber } from '@turf/helpers'
import * as Archive from '@/core/archive'

export default {
  mixins: [filters],
  name: 'unloading-fuel-create-registration',
  props: ['id'],
  components: { },
  data: () => ({
    item: {
      Amount: null,
      FileItems: [],
      Comment: null,
      Gps: null,
      NetWeightStr: '0'
    },
    acceptedFileTypes: ['png', 'jpg'],
    valid: true,
    loading: true,
    submitting: false,
    PlantList: null,
    selectedPlant: null
  }),
  computed: {
    User () {
      return Security.user.token.User
    }
  },
  methods: {
    onPickFile () {
      this.$refs.image.click()
    },
    async getGpsPosition () {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (p, e, o) => { resolve([p.coords.longitude, p.coords.latitude]) }, reject, { enableHighAccuracy: true })
      })
    },
    async saveRegistration () {
      this.submitting = true
      if (this.$refs.form.validate()) {
        for (const item of this.item.FileItems) {
          // Add a FileBytesAsBase64 property that only contain the base64 part
          // E.g.: from 'data:image/png;base64,iVBORw0KGgoAAAANSU...' to 'iVBORw0KGgoAAAANSU...'
          item.FileBytesAsBase64 = item.ImageData.substr(item.ImageData.indexOf(',') + 1)
        }
        // Valider front-end data. Fx om fuel type ikke er blank. Ved fejl vis besked og return.
        if (this.validateFrontEndData(this.item)) {
          this.item.WeightNet = this.item.NetWeightStr.replace(',', '.')
          if (this.item.WeightNet < 1) {
            this.$root.$message.showError(this.$t('Invalid weight. Please fix and retry'))
            return false
          }
          const res = await UnloadingFuel.saveRegistration(this.item) // på back-end valider front-end data OG data fra DB.
          if (res.failed) {
            this.submitting = false
            // core error handling will inform of issue
            return
          }
        } else {
          // can choose to reload the unloadFuelt item and copy gps, weight, comment and images to the new backend object
          this.submitting = false
          return
        }
      }
      this.$router.push({ name: 'unloading-fuel' })
      this.submitting = false
    },
    cancelRegistration () {
      this.$router.push({ name: 'unloading-fuel' })
    },
    validate (item) {
      var num = false
      if (this.item.NetWeightStr !== undefined) {
        item.WeightNet = this.item.NetWeightStr.replace(',', '.')
        console.log('nummer', isNumber(item.WeightNet))
        num = isNumber(item.WeightNet) // && this.item.NetWeightStr !== '0'
      }
      return item.FileItems != null ? item.FileItems.length === 0 || !num : true// || !positiveWeight : true
      /* const positiveWeight = isNumber(item.WeightNetStr) // && item.WeightNetStr > 0
      return item.FileItems != null ? item.FileItems.length === 0 || !positiveWeight : true */
    },
    savePlant (selectedPlant) {
      this.item.PlantNo = selectedPlant
      this.item.PlantName = this.getItemFromArray(this.PlantList, this.item.PlantNo, 'text')
    },
    getItemFromArray (array, findNo, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.value === findNo)
        if (found) {
          // item exists
          result = found[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    validateFrontEndData (item) {
      if (!item.ArticleNo) {
        this.$root.$message.showError(this.$t('Article is missing. Please fix and retry'))
        return false
      }
      if (!item.CustomerNo) {
        this.$root.$message.showError(this.$t('Customer is missing. Please fix and retry'))
        return false
      }
      if (!item.WasteFuelTypeNo) {
        this.$root.$message.showError(this.$t('Fuel Type is missing. Please fix and retry'))
        return false
      }
      if (!item.VehicleLicensePlateNo) {
        this.$root.$message.showError(this.$t('User licenseplate number is missing. Please fix and retry'))
        return false
      }
      if (!item.PlantNo) {
        this.$root.$message.showError(this.$t('Plant is missing. Please fix and retry'))
        return false
      }
      return true
    },
    async onFilePicked (event) {
      console.log('pop')
      const files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        const file = await readAndCompressImage(files[0], {
          quality: 0.6,
          maxWidth: 1600,
          maxHeight: 1600
        })

        const filename = files[0].name
        console.log('pop1')
        const regex = new RegExp(
          '.' + this.acceptedFileTypes.join('|') + '$',
          'i'
        )
        console.log('pop2')
        if (this.authentication) {
          if (filename && !filename.match(regex)) {
            this.$root.$message.showError(this.$t('File must be an image (jpg or png)'))
            event.target.value = ''
            return
          }
        }

        // calculate sum of all files sizes and validate max 10MB
        let sumSize = 0
        this.item.FileItems.forEach(item => { sumSize += item.ImageData.length })
        sumSize += file.size
        if (sumSize > 10000000) {
          this.$root.$message.showError(this.$t('Image collection size must be less than 10 Mb'))
          return
        }

        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.item.FileItems.push({ ImageData: fileReader.result, NameOfFile: filename })
          this.$nextTick(() => {
            mediumZoom(
              Array.from(document.querySelectorAll('.zoom')).filter(
                img => !img.classList.contains('medium-zoom-image')
              )
            )
          }, 0)
        })
        fileReader.readAsDataURL(file)
      } else {
        this.$store.dispatch('notify', {
          message: 'No file provided',
          color: 'error'
        })
        event.target.value = ''
      }
    },
    removeFile (index) {
      this.item.FileItems.splice(index, 1)
    }
  },
  async mounted () {
    // we should not be on this page with unitialised data
    if (this.$route.params.id === undefined) {
      this.$router.push({ name: 'unloading-fuel' })
    }

    mediumZoom(Array.from(document.querySelectorAll('.zoom')).filter(img => !img.classList.contains('medium-zoom-image')))

    if (this.$route.params.id) {
      const res = await UnloadingFuel.loadRegistration(this.$route.params.id)
      if (!res.failed) {
        this.item = res.data
        this.item.FileItems = []
        // this.item.NetWeightStr = this.item.NetWeight
        // this.item.NetWeightStr = '0'
      }
    }
    if (this.item.Facility === undefined) {
      this.$router.push({ name: 'unloading-fuel' })
    } else {
      const res = await Archive.loadPlants(this.item.Facility)
      if (!res.failed) {
        if (!res.data.includes('')) res.data.unshift({ No: '', Name: '' })
        this.PlantList = res.data.map(item => {
          return {
            text: item.Name,
            value: item.No,
            item: item
          }
        })
      }
    }
    if (this.item.PlantNo) {
      this.selectedPlant = this.item.PlantNo
    }
    const gpsPosition = await this.getGpsPosition()
    this.item.GpsPos = gpsPosition.reverse().toString()
  }
}
</script>

<style>
  p {
    font-size: 16px;
  }
</style>

<style scoped>
input[type='file'] {
  position: absolute;
  left: -99999px;
}
.image_container {
  position: relative;
  display: inline-block;
  text-align: center;
}
.image_container img {
  max-width: 100%;
}
.image_container .after {
  position: absolute;
  top: 0;
  left: 0;
}
.faded {
  opacity: 0.75;
}
</style>
